import Vue from 'vue'
import Confirm from './index.vue'

// 组件构造器，构造出一个 vue组件实例
const ConfirmConstructor = Vue.extend(Confirm)

function ConfirmOrder (priceInfo, classList, $id, playBackList, unionId, materialsInfo, adminUserId) {
  const dom = new ConfirmConstructor({
    el: document.createElement('div'),
    data () {
      return {
        priceInfo: {},
        showOrder: false,
        classList: [],
        materialsInfo: materialsInfo,
        playBackList: '',
        unionId: 0,
        adminUserId: adminUserId
      }
    }
  })
  dom.priceInfo = priceInfo
  dom.classList = classList
  dom.showOrder = true
  dom.playBackList = playBackList
  dom.unionId = Number(unionId)
  dom.materialsInfo = materialsInfo
  dom.adminUserId = adminUserId
  if ($id) {
    document.getElementById($id).appendChild(dom.$el)
  } else {
    document.body.appendChild(dom.$el)
  }
}

// 全局注册
export default () => {
  Vue.prototype.$confirmOrder = ConfirmOrder
}
